import React from "react";

import "./frontpage-modal.scss";


function FrontPageModal({ onClose }) {
  const handleClick = () => {
    onClose();
  };
  return (
    <section className="frontpage-modal">
      <div className="modal-content">
        <a href="#" onClick={handleClick} title="Bezár">
          <img src={`${process.env.REACT_APP_STATIC_SERVER_URL}/web/images/shop/Shop_nyitvatartasvaltozas_1920x800.jpg`} alt="Nyári nyitvatartás változás" />
        </a>
      </div>
    </section>
  );
}

export default FrontPageModal;
